var ezdia;
(function (ezdia) {
    var options = {
        order: 'asc',
        items: '',
        child: ''
    };
    function getValue(element) {
        var val = '';
        var elem = $(element);
        if (options.child) {
            elem = $(elem).find(options.child);
        }
        val = elem.text() || '';
        return val.toLowerCase();
    }
    function sorts(a, b) {
        // tslint:disable-next-line:triple-equals
        if (options.order === 'asc') {
            // eslint-disable-next-line no-nested-ternary
            return a === b ? 0 : a < b ? -1 : 1;
        }
        // eslint-disable-next-line no-nested-ternary
        return a === b ? 0 : a > b ? -1 : 1;
    }
    function getSortGroup() {
        var self = this;
        this.append(self.find(options.items).sort(function sort(a, b) {
            // eslint-disable-next-line no-param-reassign
            a = $(a).data('label').toLowerCase();
            // eslint-disable-next-line no-param-reassign
            b = $(b).data('label').toLowerCase();
            return sorts(a, b);
        }));
    }
    function sortOptgroup() {
        var self = this;
        this.append(self.find(options.items).sort(function sort(a, b) {
            // eslint-disable-next-line no-param-reassign
            a = a.label.toLowerCase();
            // eslint-disable-next-line no-param-reassign
            b = b.label.toLowerCase();
            return sorts(a, b);
        }));
    }
    function getSortList() {
        var self = this;
        this.append(self.find(options.items).sort(function sort(a, b) {
            // eslint-disable-next-line no-param-reassign
            a = getValue(a);
            // eslint-disable-next-line no-param-reassign
            b = getValue(b);
            return sorts(a, b);
        }));
    }
    function getSelect() {
        var value = this.val();
        var optgroup = this.find('optgroup');
        var items = options.items;
        if (optgroup.length) {
            options.items = 'option';
            $.each(optgroup, function each(i, opt) {
                var elem = $(opt);
                getSortList.call(elem);
            });
            options.items = 'optgroup';
            sortOptgroup.call(this);
        }
        else {
            options.items = items || 'option';
            getSortList.call(this);
        }
        this.val(value);
    }
    $.fn.sortItems = function sortItems(settings) {
        options = $.extend(options, settings);
        options.isSelect = this.is('select');
        switch (options.order) {
            case 'asc':
            case 'desc':
                break;
            default:
                return new Error('Invalid option');
        }
        if (options.isSelect) {
            getSelect.call(this);
        }
        else if (options.items &&
            (options.items === 'ul' || options.items === 'ol')) {
            getSortGroup.call(this);
        }
        else {
            options.items = options.items || 'li';
            getSortList.call(this);
        }
        return this;
    };
})(ezdia || (ezdia = {}));
